import { mergeClasses } from "@fluentui/react-components";
import { ITemplateListItemProps } from "models/ITemplate";
import React from "react";
import { renderTemplateIcon } from "utils/templateIcons";
import { useQuickStartGalleryStyles } from "./quickStartGallery.styles";

export const TemplateListItem = React.memo(
  ({ template, isActive, onClick }: ITemplateListItemProps): JSX.Element => {
    const styles = useQuickStartGalleryStyles();

    return (
      <div
        className={mergeClasses(
          styles.templateListItem,
          isActive && styles.templateListItemActive,
        )}
        onClick={onClick}
        role="button"
        tabIndex={0}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            onClick();
          }
        }}
        aria-label={`Select ${template.name} template`}
      >
        <span className={styles.templateListItemIcon}>
          {renderTemplateIcon(template.icon)}
        </span>
        <span
          className={mergeClasses(
            styles.templateListItemName,
            isActive && styles.templateListItemNameActive,
          )}
        >
          {template.name}
        </span>
      </div>
    );
  },
);
